/* OWASP Special Characters: https://www.owasp.org/index.php/Password_special_characters */ const specialCharacters = [
    ' ',
    '!',
    '"',
    '#',
    '\\$',
    '%',
    '&',
    "'",
    '\\(',
    '\\)',
    '\\*',
    '\\+',
    ',',
    '-',
    '\\.',
    '/',
    ':',
    ';',
    '<',
    '=',
    '>',
    '\\?',
    '@',
    '\\[',
    '\\\\',
    '\\]',
    '\\^',
    '_',
    '`',
    '{',
    '\\|',
    '}',
    '~', 
].join('|');
const noTripleCharacters = /^(?:(.)\1?(?!\1))+$/;
const minLength = (password, amount)=>password.length >= amount
;
const MODERATE_LENGTH = 6;
const STRONG_LENGTH = 8;
const EXCELLENT_LENGTH = 10;
const containsRequiredCharacters = (password)=>password.length >= STRONG_LENGTH
;
const lowercaseRule = /[a-z]/;
const containsLowercase = (value)=>lowercaseRule.test(value)
;
const uppercaseRule = /[A-Z]/;
const containsUppercase = (value)=>uppercaseRule.test(value)
;
const numberRule = /[0-9]/;
const containsNumber = (value)=>numberRule.test(value)
;
const specialCharacterRule = new RegExp(specialCharacters);
const containsSpecialCharacter = (value)=>specialCharacterRule.test(value)
;
// There must be three out of these four character types: lowercase, uppercase, number, symbol
const minRequiredCharacterTypes = 3;
const characterTypeRules = [
    lowercaseRule,
    uppercaseRule,
    numberRule,
    specialCharacterRule
];
function isModerate(password) {
    // level `fair` according to auth0 documentation, with caveats
    /**
   * The caveats being that we use 6 instead of 8 characters as per decision of
   * My Account Team on 08/11/22. This is done to make sure that:
   * 1) moderate password level (now requires 6 characters, previously 8) and strong (requires 8)
   * do not overlap anymore. This way we provide two distinctive levels to the customer.
   * 2) this password level is aligned with the way we show feedback to the customer
   * in the PasswordWithStrengthIndicator component
   */ /**
   * At least 6 characters including the following types:
   * - a lowercase letter
   * - an uppercase letter
   * - a number
   */ const requiredRules = [
        lowercaseRule,
        uppercaseRule,
        numberRule
    ];
    const rulesPassed = requiredRules.filter((rule)=>rule.test(password)
    );
    return minLength(password, MODERATE_LENGTH) && rulesPassed.length === requiredRules.length;
}
function isStrong(password) {
    // level `good` according to auth0 documentation
    /**
   * At least 8 characters including 3 out of the following types:
   * - a lowercase letter
   * - an uppercase letter
   * - a number
   * - a special character (such as !@#$%^&*, see OWASP special characters at the top of this file)
   */ const rulesPassed = characterTypeRules.filter((rule)=>rule.test(password)
    );
    return minLength(password, STRONG_LENGTH) && rulesPassed.length >= minRequiredCharacterTypes;
}
function isExcellent(password) {
    // Excellent
    /**
   * At least 10 characters including 3 out of the following types:
   * - a lower-case letter
   * - an upper-case letter
   * - a number
   * - a special character (such as !@#$%^&*, see OWASP special characters at the top of this file)
   *
   * Not more than 2 identical characters in a row (e.g. 555 is not allowed)
   */ const rulesPassed = characterTypeRules.filter((rule)=>rule.test(password)
    );
    const passedNoTripleCharacters = noTripleCharacters.test(password);
    return minLength(password, EXCELLENT_LENGTH) && passedNoTripleCharacters && rulesPassed.length >= minRequiredCharacterTypes;
}
function isWeak(password) {
    return !isModerate(password) && !isStrong(password) && !isExcellent(password);
}
function getPasswordStrength(password) {
    const measurements = [
        [
            'weak',
            isWeak(password)
        ],
        [
            'moderate',
            isModerate(password)
        ],
        [
            'strong',
            isStrong(password)
        ],
        [
            'excellent',
            isExcellent(password)
        ], 
    ];
    return measurements.reduce((strength, [key, value])=>value ? key : strength
    , 'weak');
}
function isPasswordBelowStrengthLevel(password, strength) {
    const currentStrength = getPasswordStrength(password);
    switch(strength){
        case 'excellent':
            return currentStrength !== 'excellent';
        case 'strong':
            return currentStrength === 'weak' || currentStrength === 'moderate';
        case 'moderate':
            return currentStrength === 'weak';
    }
}

export { EXCELLENT_LENGTH, MODERATE_LENGTH, STRONG_LENGTH, containsLowercase, containsNumber, containsRequiredCharacters, containsSpecialCharacter, containsUppercase, getPasswordStrength, isExcellent, isModerate, isPasswordBelowStrengthLevel, isStrong, lowercaseRule, minLength, noTripleCharacters, numberRule, specialCharacterRule, uppercaseRule };
//# sourceMappingURL=utils.js.map
